module.exports = __webpack_public_path__ + "static/media/user-clock.097ad001.svg";